import styled from "styled-components";

import { ExternalLink } from "ui/Link";
import { Alert } from "ui/alert";
import { GmbLocation } from "api/social-account-connect/google";

import { LoginWithGoogleButton } from "../login-with-google-button";
import { AccountList } from "../account-list";
import { GetConnectButtonState } from "../connect-button";

interface GoogleMyBusinessLocationListProps {
  className?: string;
  locations: GmbLocation[];
  getConnectButtonState: GetConnectButtonState<GmbLocation>;
  LoginWithGoogleButtonProps: {
    disabled: boolean;
    onClick(): void;
  };

  onConnect(chan: GmbLocation): void;
}

export function GoogleMyBusinessLocationList({
  className,
  locations,
  onConnect,
  getConnectButtonState,
  LoginWithGoogleButtonProps,
}: GoogleMyBusinessLocationListProps) {
  return (
    <Root className={className}>
      <p>
        You've already connected your Google account to Sked. Below are the
        available locations for that account.
      </p>
      <h4>Available locations:</h4>
      {locations.length > 0 && (
        <AccountList
          items={locations}
          onConnect={onConnect}
          renderItemLabel={(location) => (
            <>
              {location.locationName} (
              {location.address &&
              location.address.addressLines &&
              location.address.addressLines.length > 0
                ? formatGmbLocationAddress(location.address)
                : "No storefront location returned"}
              ){" "}
              {location.metadata?.mapsUri && (
                <ExternalLink href={location.metadata.mapsUri}>
                  Go to Google Business Profile location page
                </ExternalLink>
              )}
            </>
          )}
          getConnectButtonState={getConnectButtonState}
        />
      )}
      {locations.length === 0 && (
        <Alert>
          No Google Business Profile (previously Google My Business) locations
          were returned for the Google account that you connected.
        </Alert>
      )}
      <h4>Dont see your location in the list?</h4>
      <Caption>
        Try reconnecting your Google account or signing in into another one:
      </Caption>
      <ButtonContainer>
        <LoginWithGoogleButton {...LoginWithGoogleButtonProps} />
      </ButtonContainer>
    </Root>
  );
}

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
`;

const Caption = styled.p`
  font-size: 14px;
`;

const Root = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 8px;

  & > * {
    margin: 0;
  }
`;

function formatGmbLocationAddress(addr?: GmbLocation["address"]) {
  return [
    addr?.addressLines?.[0],
    addr?.locality,
    addr?.administrativeArea,
    addr?.postalCode,
  ]
    .filter(Boolean)
    .join(" ");
}
